const checkFunctions = {
    trueFalseCheck: (step) => {
        return (step.question.answer.correct) ? 1 : 0;
    },

    multipleCheck: (step) => {
        let points = 0;        
        step.question.answer.forEach(a => {
            if (a.correct) {
                points = points + 1; 
            }
        });
        return (points < 3) ? 0: 3;
    },

    multipleCheck3: (step) => {        
        return 3;
    },
    
    multipleCheck4: (step) => {
        let points = 0;
        step.question.answer.forEach(a => {
            if (a.correct) {
                points = points + 1;
            }
        });
        return points;
    },

     multipleCheck2: (step) => {
        let points = 0;        
        step.question.answer.forEach(a => {
            if (a.correct) {
                points = points + 1; 
            }
        });        
        return (points < 1) ? 0: 1;
    },

    dropDownCheck: (step) => {
        let points = 0;    
        step.question.options.forEach(o =>{
            if(o.chosen){
               points = points + 5; 
            }
        });
        return points; // (points < 20) ? 0: 20;
    },

    dropDownCheck2: (step) => {
        let points = 0;    
        step.question.options.forEach(o =>{
            if(o.chosen){
               points = points + 5; 
            }
        });
        return points;
    },

    setFalseQuestions: (step) => {
        const falseOption = step.question.options.find(o => !o.correct);        
        if (falseOption) {
            step.question.answer = falseOption;
        }
    },

    setFalseQuestionsDrop: (step) => {        
        step.question.options.forEach(o=> {
            const falseOption = o.combos.find(c => !c.valor);
            if (falseOption) {
                o.value = falseOption;
            }
         });
    },

    setFalseQuestionsMultiple: (step) => {
        step.question.answer = step.question.options.filter(o => !o.correct);        
    },

    dragandDropVerticalCheck: (step) => {
        return 1;
    },

    dragandDropMatchCheck: (step) => {
        let points = 0;        
        step.question.reactivos.forEach(a => {
            if(a.correcta == a.respuesta){
                a.resultado = 1;
                points = points + 1;
            }else{
                a.resultado = 0;
            }
        });   
        return (points < 6) ? 0: 6;
    },

    dragParagrapCheck: (step) => {
        let points = 0;
        const answers = step.question.options.filter(o => o.type === 'answer-place' && o.answer.length > 0);
        answers.forEach(a => {
            if (a.answer[0].text === a.right) {
                points+=5;
            }
        })        
        return points;
    },

    dragandDropHorizontalCheck: (step) => {
        let points = 0;        
        step.question.reactivos.forEach(a => {
            if(a.correcta == a.respuesta){
                a.resultado = 1;
                points = points + 1;
            }else{
                a.resultado = 0;
            }
        });   
        return (points < 3) ? 0: 3;
    },

    otherCheck: (step) => {        
        return 0;
    }
}

export default checkFunctions